/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */

import type { UserName } from './UserName';

export type CaseDiagnosis = {
    readonly id?: number;
    case: number;
    /**
     * JSON data representation of the macro code and front / margin / comment helper in a parseable format
     */
    macro_code?: any;
    source: CaseDiagnosis.source;
    specimen: number | null;
    user: UserName;
    diagnosis: string;
    microscopic?: string | null;
    comment?: string | null;
    report_signed?: string | null;
    readonly report_signed_offset?: string;
    readonly report_signed_timezone?: string;
    readonly created_at?: string;
    readonly updated_at?: string;
    version: number | null;
    readonly cpt_codes?: Array<string>;
    readonly icd10_code?: string;
    readonly zsd_code?: string;
    is_completed?: boolean;
    is_ai_mismatch?: boolean;
    is_mihm_assisted?: boolean;
    /**
     * True indicates the diagnosis has been screened and the finalizing pathologist agrees with the screen. The value is False if there's no screen or the pathologist doesn't agree with the screen
     */
    is_screen_valid?: boolean;
    readonly finalized_report_id?: number;
    slide_classification?: number | null;
}

export namespace CaseDiagnosis {

    export enum source {
        AI = 'ai',
        SCREEN = 'screen',
        FINALIZE = 'finalize',
        LIS_FINALIZED = 'lis-finalized',
        COMMENT = 'comment',
        AMEND = 'amend',
        ADDEND = 'addend',
        CORRECTION = 'correction',
        PRELIMINARY = 'preliminary',
    }


}
